/**
 * Created by coolguy on 2017/4/15.
 * copy from 倍棒小店项目
 */
/*eslint-disable*/
import CommonAction from '../actions/CommonAction';
import { message } from 'antd';
import url from "./url";
import { Router } from 'react-router-dom';
import { getMany, setMany } from 'idb-keyval';

let headers = {
    //反正就目前只有这个一个情况
    json: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },

    json_all: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
    }
};

//获取当前的token值（主要用于登录）
let getToken = () => {
    return window.sessionStorage['token'];
};

let notWithXToken = (opts) => {
    let { url } = opts;
    return url.indexOf('/api/user/login') === -1/* && !~url.indexOf('/image/sign')*/
};

let withFetchTimeout = (opts) => {
    let timeoutHandler = null;
    const timeoutMs = Number(opts.timeoutMs || 0);
    delete opts.timeoutMs;

    if (timeoutMs > 0 && typeof AbortController !== 'undefined') {
        const controller = new AbortController();
        opts.signal = controller.signal;
        timeoutHandler = setTimeout(() => {
            controller.abort();
        }, timeoutMs);
    }

    return {
        clear: () => {
            if (timeoutHandler) {
                clearTimeout(timeoutHandler);
                timeoutHandler = null;
            }
        },
        timeoutMs,
    };
};

let ajax = (opts, defaultHandleError = true) => {
    opts = Object.assign({}, {
        method: 'get',
        type: 'json',
        headers: headers['json'],
        credentials: 'include'//不能设置成Include，会出错，要求服务器必须得设置CORS且不能是*
    }, opts);
    !opts.method && (opts.method = 'get');
    opts.method = opts.method.toLowerCase();
    opts.body = opts.data || opts.body;
    delete opts.data;
    //如果有token，放到body中
    //let token = window.sessionStorage['token'];

    // if(token && notWithXToken(opts)
    //     ){//登录的协议不需要带上他
    //     opts.url.indexOf("?") > -1 ? opts.url+=`&x-token=${token}` : opts.url+=`?x-token=${token}`;
    // }
    var theUrl = url(opts.url);
    if (typeof opts.body != 'undefined') {
        if (opts.method === 'get') {
            var target = theUrl.mergeParams(opts.body || {});
            opts.url = target.toString();
            opts.body = undefined;
            delete opts.body;
        } else {
            //body请注意，不支持多级嵌套型的数据格式，如果有请再考虑
            opts.body = typeof opts.body == 'string' ? opts.body : theUrl.serialize(opts.body);
        }
    }
    //opts.headers = opts.method == 'post' ? headers['form'] : headers[opts.type];
    opts.headers = Object.assign({}, opts.headers, headers[opts.type]);
    const timeoutHelper = withFetchTimeout(opts);
    //  console.log(opts);
    return fetch(opts.url, opts).then(function (response) {
        timeoutHelper.clear();
        if (!response.ok) {
            //考虑到404等压根就不会按照正常的JSON格式数据给出来
            if (response.status === 401) {
                // 未登录
                if (window.location.href.indexOf('#/login') < 0) {
                    // window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
                    window.location.href = `/workwechat/login?redirect=${encodeURIComponent(window.location.href)}`;
                }
                //避免弹出多个框
                return;
            }
            return response.text().then((text) => {
                let json;
                try {
                    json = JSON.parse(text);
                } catch (e) {
                    json = {
                        detail: text
                    };
                }
                var error = new Error();
                error.name = response.status;
                console.log("---error happened---");
                console.log('http status', error.name);
                error.data = json;
                throw error;
            });
        }
        return response.json().then(function (json) {
            return json;
        });
    }).catch((e) => {
        timeoutHelper.clear();
        if (e && e.name === 'AbortError') {
            e = new Error(`请求超时(${timeoutHelper.timeoutMs}ms)`);
            e.name = 'TimeoutError';
        }
        if (defaultHandleError) {
            if (e && e.data) {
                let { error } = e.data;
                let theMessage = e.data.message;
                error && message.warn(error);
                theMessage && message.warn(theMessage);
            }
        }
        console.warn(e);
        //一定要继续抛出去，否则会被认定异常处理完成，进入成功的then了
        throw e;
    });
};

let ajaxv2 = (opts, defaultHandleError = true) => {
    opts = Object.assign({}, {
        method: 'get',
        type: 'json',
        headers: headers['json_all'],
        credentials: 'include'//不能设置成Include，会出错，要求服务器必须得设置CORS且不能是*
    }, opts);
    !opts.method && (opts.method = 'get');
    opts.method = opts.method.toLowerCase();
    opts.body = opts.data || opts.body;
    delete opts.data;
    //如果有token，放到body中
    //let token = window.sessionStorage['token'];

    // if(token && notWithXToken(opts)
    //     ){//登录的协议不需要带上他
    //     opts.url.indexOf("?") > -1 ? opts.url+=`&x-token=${token}` : opts.url+=`?x-token=${token}`;
    // }
    var theUrl = url(opts.url);
    if (typeof opts.body != 'undefined') {
        if (opts.method === 'get') {
            var target = theUrl.mergeParams(opts.body || {});
            opts.url = target.toString();
            opts.body = undefined;
            delete opts.body;
        } else {
            //body请注意，不支持多级嵌套型的数据格式，如果有请再考虑
            // opts.body = typeof opts.body == 'string' ? opts.body : theUrl.serialize(opts.body);
            opts.body = JSON.stringify(opts.body);
        }
    }
    //opts.headers = opts.method == 'post' ? headers['form'] : headers[opts.type];
    opts.headers = Object.assign({}, opts.headers, opts.method == 'post' ? headers['json_all'] : headers[opts.type]);
    const timeoutHelper = withFetchTimeout(opts);
    return fetch(opts.url, opts).then(function (response) {
        timeoutHelper.clear();
        if (!response.ok) {
            //考虑到404等压根就不会按照正常的JSON格式数据给出来
            if (response.status === 401) {
                // 未登录
                if (window.location.href.indexOf('#/login') < 0) {
                    // window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
                    window.location.href = `/workwechat/login?redirect=${encodeURIComponent(window.location.href)}`;
                }
                //避免弹出多个框
                return;
            }
            return response.text().then((text) => {
                let json;
                try {
                    json = JSON.parse(text);
                } catch (e) {
                    json = {
                        detail: text
                    };
                }
                var error = new Error();
                error.name = response.status;
                console.log("---error happened---");
                console.log('http status', error.name);
                error.data = json;
                throw error;
            });
        }
        return response.json().then(function (json) {
            if (json && json.code == 200) {
                return json.data;
            } else {
                var error = new Error();
                error.name = json.code;
                console.log("---error happened---");
                console.log('api code error', error.name);
                error.data = json;
                throw error;
            }
        });
    }).catch((e) => {
        timeoutHelper.clear();
        if (e && e.name === 'AbortError') {
            e = new Error(`请求超时(${timeoutHelper.timeoutMs}ms)`);
            e.name = 'TimeoutError';
        }
        if (defaultHandleError) {
            if (e && e.data) {
                let { error } = e.data;
                let theMessage = e.data.message;
                error && message.warn(error);
                theMessage && message.warn(theMessage);
            }
        }
        console.warn(e);
        //一定要继续抛出去，否则会被认定异常处理完成，进入成功的then了
        throw e;
    });
};

let ajaxCache = ({ api, cacheKey, onBeforeCache, data, success, testData, defaultHandleError = true }, requestOption = {}) => {
    let { ajaxStart } = CommonAction;
    return (dispatch) => {
        dispatch && dispatch(ajaxStart({ api, data, success }));
        let ajaxOptions = {
            url: api.url,
            method: api.method,
            ...requestOption
        };
        //数组不需要转换，否则会被转化成对象
        if (data instanceof Array) {
            ajaxOptions.data = data;
        } else {
            if (typeof data === 'object' && data) {
                ajaxOptions.data = { ...data }
            } else {//比如字符串之类的，都直接复制就好
                ajaxOptions.data = data;
            }
        }
        return getMany([cacheKey, `${cacheKey}_exp`]).then(([val, time]) => {
            if (Date.now() > Number(time || 0)) {
                val = null;
            }
            if (val) {
                try {
                    val = JSON.parse(val);
                } catch (e) {
                    val = null;
                }
            }
            if (val) {
                dispatch && dispatch(success(val || { ...data }));
                return val;
            } else {
                return ajax(ajaxOptions, defaultHandleError).then((json) => {
                    dispatch && dispatch(success(json || { ...data }));
                    setMany([[cacheKey, onBeforeCache(json)], [`${cacheKey}_exp`, Date.now() + 86400 * (7 + Math.round(Math.random() * 7)) * 1000]]);
                    return json;
                });
            }
        });

        return ajax(ajaxOptions, defaultHandleError).then((json) => {
            dispatch && dispatch(success(json || { ...data }));
            return json;
        });
    }
};

//新增testData字段，方便直接mock
//defaultHandleError默认为true，即默认处理出错信息，如果是false将不显示默认出错的信息
let ajaxCommon = ({ api, data, success, testData, defaultHandleError = true }, requestOption = {}) => {
    let { ajaxStart } = CommonAction;
    if (testData) {
        console.warn('当前是测试数据', api, data);
        return (dispatch) => {
            return new Promise((resolve) => {
                dispatch && dispatch(success(testData));
                resolve(testData);
            })


        }
    }
    return (dispatch) => {
        dispatch && dispatch(ajaxStart({ api, data, success }));
        let ajaxOptions = {
            url: api.url,
            method: api.method,
            ...requestOption
        };
        //数组不需要转换，否则会被转化成对象
        if (data instanceof Array) {
            ajaxOptions.data = data;
        } else {
            if (typeof data === 'object' && data) {
                ajaxOptions.data = { ...data }
            } else {//比如字符串之类的，都直接复制就好
                ajaxOptions.data = data;
            }

        }
        // let token = getToken();
        // token && (ajaxOptions.headers = {"auth-token": token});
        return ajax(ajaxOptions, defaultHandleError)
            .then((json) => {
                dispatch && dispatch(success(json || { ...data }));
                return json;
            });


    }
};

let ajaxv2Common = ({ api, data, success, testData, defaultHandleError = true }, requestOption = {}) => {
    let { ajaxStart } = CommonAction;
    if (testData) {
        console.warn('当前是测试数据', api, data);
        return (dispatch) => {
            return new Promise((resolve) => {
                dispatch && dispatch(success(testData));
                resolve(testData);
            })


        }
    }
    return (dispatch) => {
        dispatch && dispatch(ajaxStart({ api, data, success }));
        let ajaxOptions = {
            url: api.url,
            method: api.method,
            ...requestOption
        };
        //数组不需要转换，否则会被转化成对象
        if (data instanceof Array) {
            ajaxOptions.data = data;
        } else {
            if (typeof data === 'object' && data) {
                ajaxOptions.data = { ...data }
            } else {//比如字符串之类的，都直接复制就好
                ajaxOptions.data = data;
            }

        }
        // let token = getToken();
        // token && (ajaxOptions.headers = {"auth-token": token});
        return ajaxv2(ajaxOptions, defaultHandleError)
            .then((json) => {
                dispatch && dispatch(success(json || { ...data }));
                return json;
            });
    }
};

// let DOMAIN_CURRENT = "https://qa.v2.crm.jfoto.cn";
let DOMAIN_CURRENT = `//${window.location.hostname}`;

export default {
    ajax,
    ajaxv2,
    ajaxCommon,
    ajaxv2Common,
    ajaxCache,
    getToken,
    DOMAIN_CURRENT
};



// WEBPACK FOOTER //
// ./src/util/ajax.js